






































































































































import Vue, { PropType } from 'vue';
import {
  Creative,
  PaginationData,
  ModerationCreativeForm,
  statusModeration,
  Ssp,
  ResponseExport,
  Country,
  ObjectValue,
} from '@/types';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { AgGridVue } from 'ag-grid-vue';
import Table from '@/components/table/Table.vue';
import {
  Column,
  ColumnItems,
  ColumnType,
  FilterTypeField,
  Row,
} from '@/components/table/types';
import CamelToUnderscore from '@/utils/CamelToUnderscore';
import ViewCreativeModal from '@/components/moderate/ViewCreativeModal.vue';
import ModerationCreativeModal from '@/components/moderate/ModerationCreativeModal.vue';
import ViewStatusTemplate from '@/components/moderate/ViewStatusTemplate.vue';
import TopBar from '@/components/widgets/TopBar.vue';
// @ts-ignore
import { saveAs } from 'file-saver';
import filterParams from '@/components/table/utils/filterParameters';
import { mapGetters } from 'vuex';

// CONSTANTS
const EXPAND =
  'campaign,ssp_moderate,ssp_moderate.moderator,ssp_moderate.creative_moderation,campaign.screenshot,campaign.countries';
const FIELDS = 'width,height,title,description,campaign_id,file_id';

export default Vue.extend({
  name: 'ModerationCreative',
  mounted() {
    let params = filterParams.getUrlFilter(this.$route.query['filter']) || {};
    this.$store.commit('changeTitle', this.$t('pages.moderation.title'));
    this.getCreatives(params);
  },
  components: {
    AgGridVue,
    Table,
    TopBar,
    ViewCreativeModal,
    ViewStatusTemplate,
    ModerationCreativeModal,
  },
  computed: {
    ...mapGetters({
      moderateCreatives: 'campaignCreatives/getModerateCreatives',
    }),
    creatives(): Array<Creative> {
      return this.moderateCreatives.data.map((creative: Creative) => {
        return {
          id: creative.id,
          img: creative.img,
          country_codes: creative.campaign?.countries?.map(
            (country: Country): ObjectValue => {
              return {
                label: country.name,
                value: country.code,
              };
            }
          ),
          type_traffic: creative.campaign?.type_traffic,
          source_link: creative.url,
          screenshot: creative.campaign?.screenshot?.path,
          advertising_category: creative?.campaign?.advertising_category,
          ssp_moderate: creative.ssp_moderate,
        };
      });
    },
    paginationData(): PaginationData {
      return this.moderateCreatives.paginationData;
    },
  },
  methods: {
    async changeModeration(data: Array<ModerationCreativeForm>) {
      for (const item of data) {
        await this.$store.dispatch('campaignCreatives/moderation', {
          formData: {
            id: item.id,
            ssp_id: item.ssp_id,
            status: item.status,
            comment: item.comment,
            creative_id: item.creative_id,
          },
          index: item.index,
        });
      }
      this.moderationCreative.creativeId = null;
      this.moderationCreative.sspModeration = null;
      this.getCreatives(this.searchData);
    },
    modalPreviewCreativeClose() {
      this.previewCreative.modal = false;
    },
    clickByCell(data) {
      if (data.column.field == 'img') {
        this.previewCreative.modal = true;
        const creative = this.$store.getters[
          'campaignCreatives/getModerateCreatives'
        ].data.find((creative: Creative) => {
          return creative.id == data.row.id;
        });
        
        if (creative) {
          this.previewCreative.creative = creative;
        }
      }
    },
    renameKey(data: any, key: string) {
      if (!data || !data[key]) {
        return false;
      }
      Object.defineProperty(
        data,
        CamelToUnderscore(key),
        <PropertyDescriptor>Object.getOwnPropertyDescriptor(data, key)
      );
      delete data[key];
      return true;
    },
    exportData() {
      this.$confirm({
        title: this.$t('body.popup.export.title'),
        content: this.$t('body.popup.export.message'),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      })
        .then(() => {
          this.exportDataConfirmed();
        })
        .catch(() => {});
    },
    async exportDataConfirmed() {
      const response: ResponseExport = await this.$store.dispatch(
        'campaignCreatives/exportModeratedCreatives',
        this.searchData
      );
      saveAs(response.download_link, 'export.xls');
    },
    async getCreatives(searchData) {
      let columns: Array<string> = [];
      this.loadData = true;
      this.searchData = searchData;
      this.columns.map((item: Column, index) => {
        if (searchData[item.field]) {
          this.columns[index].filterValue = searchData[item.field];
        } else {
          this.columns[index].filterValue = null;
        }
      });
      if (this.searchData['sort']) {
        this.sort = this.searchData['sort'];
      }

      columns = this.columns
        .filter((col) => {
          return !!col.visible || col.visible == undefined;
        })
        .map((col) => col.field);

      columns.push(FIELDS);

      await this.$store.dispatch('campaignCreatives/loadModerateCreatives', {
        searchData: this.searchData,
        fields: columns,
        expand: EXPAND,
      });
      filterParams.saveFilter();
      this.loadData = false;
    },
    openModeration(ssp: Array<Ssp>, creativeId: number) {
      this.moderationCreative.creativeId = creativeId;
      this.moderationCreative.sspModeration = ssp;
    },
    closeModerationModal() {
      this.moderationCreative.sspModeration = null;
      this.moderationCreative.creativeId = null;
    },
    async deleteConfirmed(id: number) {
      await this.$store.dispatch('deleteCampaign', { id });
    },
  },
  data: function () {
    return {
      searchData: {},
      columns: [
        {
          name: this.$t('pages.moderation.table.header.id'),
          field: 'id',
          filterValue: null,
          useInFilter: true,
          visible: true,
        },
        {
          name: this.$t('pages.moderation.table.header.image'),
          field: 'img',
          filterValue: null,
          type: ColumnType.TYPE_IMG,
          visible: true,
          options: {
            width: '100px',
          },
        },
        {
          name: this.$t('pages.moderation.table.header.trafficType'),
          field: 'type_traffic',
          items: [
            {
              label: this.$t('body.table.body.trafficType.banner'),
              value: 'banner',
            },
            {
              label: this.$t('body.table.body.trafficType.push'),
              value: 'push',
            },
            {
              label: this.$t('body.table.body.trafficType.native'),
              value: 'native',
            },
          ] as Array<ColumnItems>,
          useInFilter: true,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.moderation.table.header.landing'),
          field: 'source_link',
          relatedField: 'screenshot',
          type: ColumnType.TYPE_LINK,
          options: {
            width: '300px',
          },
          useInFilter: true,
          filterValue: null,
        },
        {
          name: this.$t('pages.moderation.table.header.endpoint'),
          field: 'endpoint',
          useInFilter: true,
          filterValue: null,
        },
        {
          name: this.$t('pages.moderation.table.header.geo'),
          field: 'country_codes',
          items: [],
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.moderation.table.header.category'),
          field: 'advertising_category',
          items: [],
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.moderation.table.header.status'),
          field: 'status',
          items: [
            {
              label: this.$t('pages.moderation.table.body.status.approve'),
              value: statusModeration.APPROVE,
            },
            {
              label: this.$t('pages.moderation.table.body.status.rejected'),
              value: statusModeration.REJECT,
            },
            {
              label: this.$t('pages.moderation.table.body.status.new'),
              value: statusModeration.NEW,
            },
          ] as Array<ColumnItems>,
          useInFilter: true,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.moderation.table.header.createDate'),
          field: 'updated_at',
          filterTypeField: FilterTypeField.FILTER_TYPE_DATERANGE,
          useInFilter: true,
          filterValue: null,
          visible: true,
        },
        {
          name: '',
          field: 'actions',
          type: ColumnType.TYPE_ACTIONS,
          useInFilter: false,
          filterValue: null,
        },
      ] as Array<Column>,
      currentExchange: null,
      loadData: true,
      rowData: null as Array<any> | null,
      gridOptions: {
        pagination: true,
      },
      previewCreative: {
        modal: false,
        creative: null as Creative | null,
      },
      moderationCreative: {
        creativeId: null as number | null,
        sspModeration: null as Array<Ssp> | null,
      },
      sort: null as string | null,
    };
  },
});
